import { Select } from 'antd';
import React from 'react';
import { useGetCapabilitiesQuery } from '../../graphql/schema';

interface Props {
  value?: string | null;
  onChange?: (id?: string | null) => void;
}

interface Option {
  label: string;
  value?: string | null;
}

const CapabilitySelect = ({ value, onChange }: Props) => {
  const { data, loading } = useGetCapabilitiesQuery();

  const options: Option[] =
    data?.capabilities.map((item) => {
      return {
        label: item.label,
        value: item.id,
      };
    }) || [];

  return (
    <Select
      onChange={onChange}
      loading={loading}
      value={value}
      options={options}
      className="w-full"
    />
  );
};

export default CapabilitySelect;
